import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import Informacoes from './informacoes';
import Senha from './senha';
import Aprovacao from './aprovacao';
import { signUp } from '../../services';
import { Button, StepperController, Loader } from '../../components';
import { icons } from '../../assets';
import * as s from './styled-register';

const Register = ({ setIsOpen }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [activeStep, setActiveStep] = useState(0);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { colors } = useContext(ThemeContext);

  const steps = [
    'Adicione suas Informações',
    'Adicione uma senha',
    'Solicite Aprovação',
  ];

  const messageByStatus = (code) => {
    if (code === 'UsernameExistsException')
      return 'Uma conta com este e-mail já existe.';
    return 'Desculpe, ocorreu um erro ao criar seu usuário :(';
  };

  const handleRegister = () => {
    setLoading(true);
    setActiveStep(3);
    signUp(username, password, email, phoneNumber)
      .then(() => {
        setIsOpen(false);
        setLoading(false);
      })
      .catch((e) => {
        setErrorMessage(messageByStatus(e.code));
        setLoading(false);
      });
  };

  const isEmailValid = () => {
    const re = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    if (!re.test(email)) return true;
    return false;
  };

  // const handleConfirmSignUp = () => {
  //   setLoading(true);
  //   confirmSignUp(username, verificationCode)
  //     .then(() => {
  //       setConfirmation(false);
  //       setLoading(false);
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //       return 'Erro no código';
  //     });
  // };
  const ShouldAnimate = () => {
    switch (activeStep) {
      case 0:
        if (username && phoneNumber && email && !isEmailValid()) return true;
        break;
      case 1:
        if (password && password.length >= 8 && confirmPassword === password)
          return true;
        break;
      default:
        return false;
    }
  };

  return (
    <s.Container className="fade-in">
      <s.StepperConteiner>
        <StepperController activeStep={activeStep} steps={steps} />
        <s.Icon
          src={icons.CloseIcon}
          alt="fechar-modal"
          size="21px"
          margin="0 0 0 auto"
          onClick={() => setIsOpen(false)}
          pointer
        />
      </s.StepperConteiner>

      <s.ContentContainer>
        {activeStep === 0 ? (
          <Informacoes
            username={username}
            email={email}
            phoneNumber={phoneNumber}
            setUsername={setUsername}
            setEmail={setEmail}
            setPhoneNumber={setPhoneNumber}
          />
        ) : activeStep === 1 ? (
          <Senha
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            errorMessage={errorMessage}
          />
        ) : (
          <Aprovacao
            username={username}
            email={email}
            phoneNumber={phoneNumber}
            loading={loading}
          />
        )}
      </s.ContentContainer>

      <s.FooterContainer>
        {errorMessage && <s.ErrorMessage>{errorMessage}</s.ErrorMessage>}
        <div id="buttonContainer">
          {activeStep === 0 ? (
            <Button
              label="Próximo"
              onClick={() => setActiveStep(1)}
              background={colors.darkblue}
              color={colors.white}
              width="500px"
              animate={ShouldAnimate()}
              disabled={!username || !email || !phoneNumber || isEmailValid()}
            />
          ) : activeStep === 1 ? (
            <>
              <Button
                label="Voltar"
                onClick={() => setActiveStep(0)}
                background={colors.white}
                color={colors.darkblue}
                width="250px"
              />
              <div style={{ margin: '0 20px' }} />
              <Button
                label="Próximo"
                onClick={() => setActiveStep(2)}
                background={colors.darkblue}
                color={colors.white}
                width="250px"
                animate={ShouldAnimate()}
                disabled={
                  !password ||
                  password.length < 8 ||
                  confirmPassword !== password
                }
              />
            </>
          ) : (
            <>
              <Button
                label="Voltar"
                onClick={() => setActiveStep(1)}
                background={colors.white}
                color={colors.darkblue}
                width="250px"
                disabled={loading}
              />
              <div style={{ margin: '0 20px' }} />
              <Button
                label={
                  !loading ? 'Solicitar' : <Loader width="25px" height="25px" />
                }
                onClick={() => handleRegister()}
                background={colors.darkblue}
                color={colors.white}
                animate
                width="250px"
                disabled={loading}
              />
            </>
          )}
        </div>
        <s.Icon
          src={icons.Logotipo}
          alt="logoHygra"
          width="110px"
          height="30px"
        />
      </s.FooterContainer>
    </s.Container>
  );
};

export default withRouter(Register);
